<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">外协算税</li>
    </ul>
    <ul class="c-list-search">
      <c_statusradiogroup
        v-model="state.params.status"
        arrName="calctaxoutsource_status"
        @change="onLoad"
      ></c_statusradiogroup>
      <el-input
        v-model="state.params.keywords"
        style="width: 200px"
        placeholder="名称、单号、工资表单号"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <el-input
        v-model="state.params.keywords_employee"
        style="width: 200px"
        placeholder="员工姓名、手机号、证件号"
        clearable
        @clear="
          delete state.params.keywords_employee;
          onLoad();
        "
        @paste.enter="
          $onKeywordsPaste($event, state.params, 'keywords_employee')
        "
      ></el-input>
      <el-select
        v-model="state.params.customer_id"
        placeholder="所属客户"
        style="width: 200px"
      >
        <el-option
          v-for="item in state.customer_data"
          :key="item"
          :label="item.name"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()">刷新</el-button>
        </template>
      </el-select>
      <el-select
        v-model="state.params.d_tax_type_id"
        placeholder="报税类型"
        style="width: 200px"
      >
        <el-option
          v-for="item in state.taxType_data"
          :key="item"
          :label="item.name"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadTaxType()"> 刷新 </el-button>
        </template>
      </el-select>
      <el-select
        v-model="state.params.withholding_agent_id"
        placeholder="供应商"
        style="width: 200px"
      >
        <el-option
          v-for="item in state.supplier_data"
          :key="item"
          :label="item.name"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadSupplier()"> 刷新 </el-button>
        </template>
      </el-select>
      <el-date-picker
        v-model="state.params.tax_month"
        type="month"
        placeholder="税款所属期"
        format="YYYY年M月"
        value-format="YYYY-MM"
        style="width: 140px"
      />
      <el-tree-select
        v-model="state.params.belonger_id"
        :props="{
          value: 'id',
          label: 'name',
          class: 'belonger-tree-class',
        }"
        placeholder="负责人"
        :data="state.admin_data"
        style="width: 200px"
        default-expand-all
        filterable
        clearable
      >
        <template #default="{ data }">
          <el-icon :size="16" v-if="data.type == 0"><UserFilled /></el-icon>
          <el-icon :size="16" v-else><User /></el-icon>
          <span style="margin-left: 3px">{{ data.name }}</span>
        </template>
      </el-tree-select>
      <el-date-picker
        v-model="state.dates"
        type="daterange"
        range-separator="至"
        start-placeholder="发薪日期"
        end-placeholder="发薪日期"
        style="flex-grow: unset"
        value-format="YYYY-MM-DD"
        @change="
          (value) => {
            if (value) state.params.pay_date = value[0] + ' - ' + value[1];
          }
        "
        @clear="
          delete state.dates;
          delete state.params.pay_date;
        "
      />
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          label="状态/单号"
          sortable="collected_status"
          width="120"
        >
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <c_status
                  arrName="calctaxoutsource_status"
                  :value="row.status"
                />
              </template>
              <template #bottom>
                <text
                  style="color: #1e90ff"
                  class="text-hover-decoration"
                  title="单号"
                  @click="$onCopy(row.order_id)"
                >
                  {{ row.order_id }}
                </text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          label="名称/所属客户"
          :formatter="
            (row) => $tab_GroupFormat(row.name, row.customer_name || '')
          "
          min-width="240"
        />
        <el-table-column
          prop="d_tax_type_name"
          label="报税类型"
          :formatter="$tab_TextFormat"
          width="180"
        />
        <el-table-column
          prop="tax_month"
          label="税款所属期"
          :formatter="$tab_TextFormat"
          width="120"
          align="center"
        />
        <el-table-column
          prop="pay_date"
          label="发薪时间"
          :formatter="$tab_TextFormat"
          width="120"
          align="center"
        />
        <el-table-column
          prop="withholding_agent_name"
          label="供应商"
          :formatter="$tab_TextFormat"
          min-width="220"
        />
        <el-table-column
          prop="total_num"
          label="算税人数"
          :formatter="$tab_TextFormat"
          align="center"
          width="120"
        />
        <el-table-column
          prop="done_num"
          label="已算税"
          :formatter="$tab_NumberFormat"
          align="center"
          width="120"
        />
        <el-table-column
          prop="undone_num"
          label="未算税"
          :formatter="$tab_NumberFormat"
          align="center"
          width="120"
        />
        <el-table-column
          prop="abnormal_num"
          label="算税失败"
          :formatter="$tab_NumberFormat"
          align="center"
          width="120"
        />
        <el-table-column label="负责人" width="180">
          <template #default="{ row }">
            <c_tabgroup
              :value1="row.add_admin_name || '-'"
              :value2="row.add_department_name"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="120"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Edit"
              @click="
                $store.commit('openMenu', {
                  path: 'CalcTaxOutsourceDetail',
                  title: '外协算税单详情-' + row.order_id,
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
              v-if="$judge_auth('57')"
            >
              算税填报
            </el-button>
            <el-button
              type="primary"
              link
              icon="View"
              @click="
                $store.commit('openMenu', {
                  path: 'CalcTaxOutsourceDetail',
                  title: '外协算税单详情-' + row.order_id,
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
              v-else
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { calctaxoutsource_list } from "@/http/calctaxoutsource";
import { data_supplier_select, data_customer_select } from "@/http/data";
import { taxtype_select } from "@/http/dictionary";
import { admin_cascader } from "@/utils/qFormat";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_value: "desc",
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoadCustomer();
      onLoadTaxType();
      onLoadSupplier();
      onLoadAdmin();
      onLoad();
    });

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customer_data = res.data.data?.list;
      });
    };

    //获取报税类型
    const onLoadTaxType = () => {
      taxtype_select().then((res) => {
        if (res.status == 200) state.taxType_data = res.data.data;
      });
    };

    //加载供应商
    const onLoadSupplier = () => {
      data_supplier_select().then((res) => {
        if (res.status == 200) state.supplier_data = res.data.data?.list;
      });
    };

    //加载负责人
    const onLoadAdmin = () => {
      admin_cascader().then((res) => {
        state.admin_data = res;
      });
    };

    const onLoad = () => {
      delete state.tableData;

      calctaxoutsource_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    return {
      state,
      onLoadCustomer,
      onLoadSupplier,
      onLoadTaxType,
      onLoadAdmin,
      onLoad,
      onSortChange,
      onReset,
    };
  },
};
</script>
<style lang="less">
.bank-received-index-tab-pop {
  .el-descriptions__header {
    margin-bottom: 0 !important;
  }
}
</style>
